//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestPriorityField from '../Request/RequestPriorityField.vue'
import RequestRedirectedWorkAreaField from '../Request/RequestRedirectedWorkAreaField.vue'
import RequestAutoAssignItem from '../Request/RequestAutoAssignItem.vue'
import RequestForkliftTruckField from '../Request/RequestForkliftTruckField.vue'
import RequestWorksSimpleSection from '../Request/RequestWorksSimpleSection.vue'
import RequestMapPopupExecutor from '../Request/RequestMapPopup/RequestMapPopupExecutor.vue'
import CardSeparator from '../../components/Card/CardSeparator.vue'
import Comments from '../../components/Comments/Comments.vue'
import { addRequestProperties, convertRequestToServer, getRequestRoles } from '../Request/Request.js'

function deepCloneProperty (object, clone, propertyName) {
  clone[propertyName] = JSON.parse(JSON.stringify(object[propertyName]))
}

function deepCloneProperties (object, clone, propertiesConfigs) {
  propertiesConfigs.forEach(propertyConfig => {
    deepCloneProperty(object, clone, propertyConfig.name)
  })
}

const REQUEST_PROPERTIES = [
  // { name: 'proposedExecutorObject', type: 'object' },
  { name: 'bpStateId', type: 'string', computed: true },
  { name: 'actionsProps', type: 'boolean', computed: true },
  { name: 'requestPriority', type: 'number', serverName: 'executionPriority' },
  { name: 'redirectedWorkAreaKey', type: 'string', serverName: 'redirectedWorkArea' }, // serviceObject
  { name: 'autoAssign', type: 'boolean' }, // requestId
  { name: 'forkliftTruckRequired', type: 'boolean' },
  { name: 'requestForkliftTruck', type: 'object' },
  { name: 'workTypes', type: 'objects', includeWith: ['workPackages'] }, // requestType, serviceObjectType
  { name: 'workTypesContractor', type: 'objects', includeWith: ['workPackagesContractor'] },
  { name: 'workPackages', type: 'objects', includeWith: ['workTypes'] },
  { name: 'workPackagesContractor', type: 'objects', includeWith: ['workTypesContractor'] },
  { name: 'autoAssignBrigadeWorkTypes', type: 'objects', serverName: 'requestAutoAssignBrigadeWorkType', includeWith: ['autoAssignBrigadeWorkPackages'] }, // bpStateId, audit, auditObject
  { name: 'autoAssignBrigadeWorkPackages', type: 'objects', serverName: 'requestAutoAssignBrigadeWorkPackage', includeWith: ['autoAssignBrigadeWorkTypes'] }
]

export default {
  name: 'AdditionalDepartureRequiredCard',
  components: {
    RequestPriorityField,
    RequestRedirectedWorkAreaField,
    RequestAutoAssignItem,
    RequestForkliftTruckField,
    RequestWorksSimpleSection,
    RequestMapPopupExecutor,
    Comments,
    CardSeparator
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    requestRoles: {
      type: Object,
      required: true
    },
    executorSelection: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      reason: '',
      requestLocal: null,
      requestRolesLocal: null,
      created: false
    }
  },
  computed: {
    isContractorDispatcher: function () {
      const user = this.$store.getters.getUser // this.requestRoles.user
      return !user.roles.root && user.hasRole('contractorDispatcher') // this.requestRoles.roleContractorDispatcher
    },
    executorChangeAvailableByContractor: function () {
      if (this.isContractorDispatcher) {
        return !!this.request && !!this.request.actionsProps.BS10_contractorDispatcher && this.request.bpStateId === 'BS8'
      }
      return false
    }
  },
  watch: {
    'requestLocal.redirectedWorkAreaKey': function (value) {
      if (this.created && value) {
        this.requestLocal.autoAssign = false
      }
    }
  },
  created: function () {
    const user = this.$store.getters.getUser
    const request = this.request
    const requestLocal = Object.assign({}, request)

    deepCloneProperties(request, requestLocal, REQUEST_PROPERTIES)
    requestLocal.bpStateId = 'BS10' // чтобы проверки доступов к полям соответствовали состоянию BS10, в которое заявка переводится
    addRequestProperties(requestLocal, null, user)
    this.requestLocal = requestLocal
    this.requestRolesLocal = getRequestRoles(requestLocal, user, 'AdditionalDepartureRequiredCard')

    this.$nextTick(() => {
      this.created = true
    })
  },
  methods: {
    onApply () {
      const field = this.$refs.reason
      field.validate()
      if (field.hasError) {
        return
      }

      const requestInitial = this.request.initialObject
      const requestInitialData = convertRequestToServer(requestInitial)
      const requestLocal = this.requestLocal
      const requestLocalData = convertRequestToServer(requestLocal)
      const resultRequestProperties = {}
      REQUEST_PROPERTIES.forEach(propertyConfig => {
        if (!propertyConfig.computed) {
          const propertyName = propertyConfig.serverName || propertyConfig.name
          const initialValue = requestInitialData[propertyName]
          const localValue = requestLocalData[propertyName]
          if (JSON.stringify(initialValue) !== JSON.stringify(localValue)) {
            resultRequestProperties[propertyName] = requestLocalData[propertyName]
            if (propertyConfig.includeWith) {
              propertyConfig.includeWith.forEach(propertyToInclude => {
                const propertyToIncludeObject = REQUEST_PROPERTIES.find(p => p.name === propertyToInclude)
                const propertyToIncludeName = propertyToIncludeObject.serverName || propertyToIncludeObject.name
                resultRequestProperties[propertyToIncludeName] = requestLocalData[propertyToIncludeName]
              })
            }
          }
        }
      })
      if (this.executorSelection) {
        if (requestLocal.proposedExecutorObject && JSON.stringify(requestInitial.proposedExecutorObject) !== JSON.stringify(requestLocal.proposedExecutorObject)) {
          if (requestLocal.proposedExecutorObject.type === 'brigade') {
            const brigade = requestLocal.proposedExecutorObject.executor

            const executorToAssign = {} // аналогично /request/addRequestToBrigade
            executorToAssign.brigadeId = brigade.brigadeId
            executorToAssign.workDate = brigade.workDateMillis
            executorToAssign.workShift = brigade.workShift
            if (requestInitial.autoAssign) {
              executorToAssign.ignoreAutoAssignment = true
            }

            resultRequestProperties.executorToAssign = executorToAssign
          } else {
            throw new Error('Должна быть выбрана бригада')
          }
        }
      }

      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      this.callback({
        reason: this.reason,
        requestProperties: resultRequestProperties
      }, true).then(() => {
        this.$emit('cancel')
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    onCancel () {
      this.callback(null, false)
      this.$emit('cancel')
    }
  }
}
